import { GatherEventEmitter } from "gather-common-including-video/dist/src/public/GatherEventEmitter";
export class BasePeerManager extends GatherEventEmitter {
    info = {};
    rtcStatsManager;
    videoElementInfo = new Map();
    screenElementInfo = new Map();
    constructor(rtcStatsManager) {
        super();
        this.rtcStatsManager = rtcStatsManager;
    }
    start(_id, _spaceId, _eventEmitter) { }
    produceStart(_kind, _track, _pause) { }
    produceResume(_kind) { }
    producePause(_kind) { }
    produceEnd(_kind) { }
    subscribe(_id, _tagSet) { }
    unsubscribe(_id) { }
    destroy() { }
    allow(_id) { }
    disallow(_id) { }
    startObserve(_id, _elementInfo, _kind) { }
    stopObserve(_id, _kind) { }
    setAdaptiveStream(_active) { }
    setAdaptiveStreamSettings(_options) { }
    setMaxConsumerLayers(_id, _tag, _spatialLayer, _temporalLayer) { }
    setLocalVideoCaptureResolution(_width, _height) { }
    setIsAVInterruptible(_isAVInterruptible) { }
    setMute(_id, _kind, _muted) { }
    setAllMuted(_kind, _muted, _exceptedPlayer) { }
    setBitrateManager(_enabled) { }
    getInfo(_id) {
        return undefined;
    }
    connectToServerIfNotConnected() { }
    getWebrtcConnectionInfo(_id, _extraParams) {
        return;
    }
    debugInfo() { }
    requestServerDebug() { }
    addLatestSpeaker(_id) { }
    simulateScenario(_scenario, _id, _kind, _paused) { }
    async getConnectionReport(_userId) {
        return {};
    }
    getActiveVideoElements() {
        return;
    }
    networkChanged() { }
}
//# sourceMappingURL=BasePeerManager.js.map